import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestHelper } from '@shared/helpers';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class ShiftSettingApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/shfft-settings`;
    }

    getAll(): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/all`);
    }

    getShiftSettings(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    createShiftSetting(shiftSetting: any): Observable<any> {
        return this.httpClient.post<any>(this.url, shiftSetting);
    }

    updateShiftSetting(shiftSetting: any): Observable<any> {
        return this.httpClient.put<any>(this.url, shiftSetting);
    }
}
